export const menu = [
  // {
  //   type: 'school',
  //   from: '',
  //   name: '校徽',
  //   placeholder: '校徽可以凸显名校背景',
  //   iconfont: 'iconbriefcase'
  // },
  {
    type: 'works',
    from: '',
    name: '实习/工作经历',
    cn_default_name: '实习/工作经历',
    en_default_name:'PROFESSIONAL EXPERIENCE',
    placeholder: '展示申请岗位相关的经验与能力',
    iconfont: 'iconbriefcase'
  },{
    type: 'orgs',
    from: '',
    name: '社团和组织经历',
    cn_default_name: '社团和组织经历',
    en_default_name:'LEADERSHIP EXPERIENCE',
    placeholder: '展现人际交往与团队合作能力',
    iconfont: 'iconusers'
  },{
    type: 'edus',
    from: '',
    name: '教育经历',
    cn_default_name: '教育经历',
    en_default_name:'EDUCATION',
    placeholder: '介绍学历背景与专业素养',
    iconfont: 'iconbook-open'
  },{
    type: 'extras',
    from: 'custom',
    name: '其他',
    cn_default_name: '其他',
    en_default_name:'SKILLS, CERTIFICATIONS & OTHERS',
    placeholder: '突出掌握的技能和证书',
    iconfont: 'icongrid'
  },{
    type: 'project_experience',
    from: 'custom',
    name: '项目经历',
    cn_default_name: '项目经历',
    en_default_name:'PROJECT EXPERIENCE',
    placeholder: '介绍专业领域的项目经验与能力',
    iconfont: 'iconbox'
  },{
    type: 'reasearch_experience',
    from: 'custom',
    name: '研究经历',
    cn_default_name: '研究经历',
    en_default_name:'RESEARCH EXPERIENCE',
    placeholder: '展现专业经验与能力',
    iconfont: 'iconclipboard'
  },{
    type: 'honor',
    from: 'custom',
    name: '荣誉奖项',
    cn_default_name: '荣誉奖项',
    en_default_name:'HONORS & AWARDS',
    placeholder: '含金量高的奖项是很好的加分项',
    iconfont: 'iconaward'
  },
  // {
  //   type: 'objective',
  //   from: 'custom',
  //   name: '求职意向',
  //   cn_default_name: '求职意向',
  //   en_default_name:'OBJECTIVE', 
  //   placeholder: '',
  //   iconfont: ''
  // },
  {
    type: 'personal_summary',
    from: 'custom',
    name: '个人总结',
    cn_default_name: '个人总结',
    en_default_name:'SUMMARY',
    placeholder: '总结优势，突出亮点',
    iconfont: 'iconuser'
  },{
    type: 'skill_list',
    from: 'custom',
    name: '专业技能',
    cn_default_name: '专业技能',
    en_default_name:'SKILLS LIST',
    placeholder: '列出自己掌握的技能，展示强项',
    iconfont: 'icontag'
  },{
    type: 'opus',
    from: '',
    name: '作品集',
    cn_default_name: '作品集',
    en_default_name:'PORTFOLIO',
    placeholder: '上传作品链接，展现你的实力',
    iconfont: 'iconpen-tool',
    hasVip: true
  },{
    type: 'custom',
    from: 'custom',
    name: '自定义',
    cn_default_name: '自定义',
    en_default_name:'CUSTOM SECTION',
    placeholder: '其他需要自行添加的内容',
    iconfont: 'iconfile-plus'
  }
];

